import { Modal } from '@/components/Modal'
import { ModalPublicProps } from '../types'
import { modalId } from '../modalId'
import { Content } from './Content'
import { ContextProvider } from './ContextProvider'

export function Root(props: ModalPublicProps) {
  return (
    <Modal modalId={modalId}>
      <ContextProvider {...props}>
        <Content />
      </ContextProvider>
    </Modal>
  )
}
